<template>
    <div class="fixed-box" :style="`height:${show ? '190px' : '140px'}`">
        <div v-if="showAi" class="fixed-item ai-item" @click="goHelpCenter('zhineng')">
            <img class="item_img" src="@/assets/images/avatar.png" alt="客服" />
            <div>智能客服</div>
        </div>
        <template v-else>
            <div class="fixed-item" @click="goQestion">
                <span class="icons icon-issue"></span>
                <div>常见问题</div>
            </div>
            <div class="fixed-item" @click="goReply">
                <span class="icons icon-feedback"></span>
                <div>问题反馈</div>
            </div>
            <div class="fixed-item" @click="goHelpCenter">
                <span class="icons icon-customer"></span>
                <div>在线客服</div>
            </div>
        </template>
        <div
            :class="['fixed-item', {'fixed-item-hide': !show}]" 
            @click="scrollTop">
            <span class="icons icon-top"></span>
        </div>
        <!-- 智能客服 -->
        <iframe
            v-if="showIframe"
            :src="domain.account + '/CustomerService/aiChat?scene=' + scene"
            frameborder="0"
            class="kfIframe"
            ref="kfIframe"></iframe>
    </div>
</template>

<script>
import MDRouter from "@/service/router"
import domain from '@/service/domain'
export default {
    props: ["show"],
    data() {
        return {
            showIframe: false,
            scene: '',
            domain,
            showAi: false,
            // 显示智能客服的页面列表
            menuList: [
                {
                    name: '认证',
                    url: '/identity/type',
                    scene: 'auth'
                },
            ]
        }
    },
    watch: {
        '$route.path': {
            handler() {
                this.updateScene()
            },
            immediate: true
        }
    },
    mounted() {
        this.onIframeLoad()
    },
    methods: {
        updateScene() {
            const path = this.$route.path
            this.showAi = false
            this.scene = ''
            this.menuList.forEach(item => {
                if (path.includes(item.url)) {
                    this.showAi = true
                    this.scene = item.scene
                }
            })
        },
        onIframeLoad() {
            // 监听iframe内部的消息
            window.addEventListener('message', this.handleIframeMessage);
        },
        handleIframeMessage(event) {
            
            if (event.data === 'close-iframe') {
                this.showIframe = false;
            }
        },
        goQestion() {
            window.open('https://zhongchou.modian.com/helpcenter/index')
        },
        goReply() {
            window.open('https://zhongchou.modian.com/helpcenter/reply?_ga=2.80450007.19177274.1666930957-1226901126.1666159598')
        },
        goHelpCenter(type) {
            if (type === 'zhineng') {
                this.showIframe = true
            } else {
                MDRouter.goServeCenter()
            }
        },
        scrollTop() {
            window.scrollTo(0, 0);
        }
    },
    beforeUnmount() {
        // 移除事件监听器
        window.removeEventListener('message', this.handleIframeMessage);
    },
}
</script>

<style lang="scss" scoped>
.fixed-box {
    position: fixed;
    right: 30px;
    bottom: 30px;
    z-index: 9999;
    height: 210px;
    transition: height 0.15s;
    .fixed-item {
        font-size: 20px;
        width: 40px;
        height: 40px;
        background-color: #F8F8F8;
        border-radius: 4px;
        border: 1px solid #E8E8E8;
        margin-bottom: 10px;
        color: #7F7F7F;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        position: relative;
        &-hide {
            visibility: hidden;
        }
        div {
            font-size: 12px;
            background-color: #1A1A1A;
            color: #fff;
            position: absolute;
            padding: 5px;
            line-height: 1;
            white-space: nowrap;
            border-radius: 2px;
            left: -100%;
            transform: translateX(-50%);
            display: none;
        }
        span {
            &.icon  {
                font-size: 20px;
            }
        }
        &:hover {
            color: #1A1A1A;
            border-color: #1A1A1A;
            position: relative;
            div{
                display: block;
            }
        }
        &.ai-item {
            margin-left: -14px;
            display:flex;
            flex-direction: column;
            justify-content: center;
            align-items:center;
            width: 68px;
            height: 68px;

            background: #FFFFFF;
            border-radius: 8px;
            border: 1px solid #E8E8E8;
            box-shadow: 0px 4px 30px 0px rgba(34, 44, 55, .1);
            cursor:pointer;

            .item_img{
                width: 32px;
                height:32px;
                margin-bottom: 5px;
            }

            div {
                left: -60%;
            }
        }
    }
    .kfIframe {
        position: fixed;
        right: 10px;
        bottom: 10px;
        width: 530px;
        height: 700px;
        max-height: 100vh;
        border-radius: 10px;
        box-shadow: 0px 0px 30px 0px rgba(#222C37, 0.1);
        transition: opacity 0.3s ease-in-out;
        z-index: 2000;
    }
}
</style>